import React from 'react';
import {ReactComponent as CutleryIco} from "../../../../../../../../../../../images/icons/cutlery.svg";

interface Props {
    name: string;
    active: boolean;
    onClick: () => void;
}

const MultistoreMenuTab = ({name, active, onClick}: Props) => {
    return (
        <button className={`btn btn-default btn-lg text-nowrap ${active ? "active" : ""}`} onClick={onClick}>
            <CutleryIco className="me-2"/>
            {name}
        </button>
    )
}

export default MultistoreMenuTab;